import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { Container, Row, Col, Card, Spinner, Button, Form, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import axios from '../../api/axios';

const AddPurchase = () => {
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const accessToken = localStorage.getItem("authToken");
  const [inputData, setInputData] = useState({
    vendor: "",
    idNumber: "",
    additionalCharges: "",
    procurementItems: [
      {
        material: "",
        quantity: "",
        rate: "",
        taxPercent: "",
      },
    ],
  });
  const [vendors, setVendors] = useState([]);
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [rawMaterialDetail, setRawMaterialDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    vendor: "",
    idNumber: "",
    additionalCharges: "",
    invoiceFile: "",
    procurementItems: [
      {
        material: "",
        quantity: "",
        rate: "",
      },
    ],
  });

  const handleAddItem = () => {
    const procurementItemErrors = inputData.procurementItems.map(
      validateProcurementItem
    );
    if (
      procurementItemErrors.some((errors) => Object.keys(errors).length > 0)
    ) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        procurementItems: procurementItemErrors,
      }));
      return;
    }

    setInputData((prevData) => ({
      ...prevData,
      procurementItems: [
        ...prevData.procurementItems,
        {
          material: "",
          quantity: "",
          rate: "",
          taxPercent: "",
        },
      ],
    }));
  };

  const handleRemoveItem = (index) => {
    setInputData((prevData) => {
      const updatedItems = [...prevData.procurementItems];
      updatedItems.splice(index, 1);
      return {
        ...prevData,
        procurementItems: updatedItems,
      };
    });
  };

  // const handleChange = (e, index) => {
  //   const { name, value } = e.target;
  //   let sanitizedValue = value;

  //   if (name === "idNumber") {
  //     sanitizedValue = value
  //   }

  //   setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  //   setValidationErrors((prevErrors) => ({
  //     ...prevErrors,
  //     procurementItems: [],
  //   }));

  //   if (name === "material" || name === "quantity" || name === "rate") {
  //     if (name === "material") {
  //       getSingleRawMaterialDetail(value, index);
  //     }

  //     setInputData((prevData) => {
  //       const updatedProcurementItems = [...prevData.procurementItems];
  //       updatedProcurementItems[index] = {
  //         ...updatedProcurementItems[index],
  //         [name]: value,
  //       };

  //       const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
  //         updatedProcurementItems[index].rate,
  //         updatedProcurementItems[index].quantity,
  //         updatedProcurementItems[index].taxPercent
  //       );

  //       updatedProcurementItems[index] = {
  //         ...updatedProcurementItems[index],
  //         taxable,
  //         taxAmount,
  //         grandTotal,
  //       };

  //       return {
  //         ...prevData,
  //         procurementItems: updatedProcurementItems,
  //       };
  //     });
  //   } else {
  //     setInputData((prevData) => ({
  //       ...prevData,
  //       [name]: sanitizedValue,
  //     }));
  //   }
  // };

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    // ✅ Allow EVERYTHING for idNumber
    if (name === "idNumber") {
      setValidationErrors((prev) => ({ ...prev, idNumber: "" }));

      setInputData((prevData) => ({
        ...prevData,
        idNumber: value,
      }));

      return; // ⛔ STOP HERE — very important
    }

    let sanitizedValue = value;

    setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      procurementItems: [],
    }));

    if (name === "material" || name === "quantity" || name === "rate") {
      if (name === "material") {
        getSingleRawMaterialDetail(value, index);
      }

      setInputData((prevData) => {
        const updatedProcurementItems = [...prevData.procurementItems];
        updatedProcurementItems[index] = {
          ...updatedProcurementItems[index],
          [name]: value,
        };

        const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
          updatedProcurementItems[index].rate,
          updatedProcurementItems[index].quantity,
          updatedProcurementItems[index].taxPercent
        );

        updatedProcurementItems[index] = {
          ...updatedProcurementItems[index],
          taxable,
          taxAmount,
          grandTotal,
        };

        return {
          ...prevData,
          procurementItems: updatedProcurementItems,
        };
      });
    } else {
      setInputData((prevData) => ({
        ...prevData,
        [name]: sanitizedValue,
      }));
    }
  };


  const calculateTaxAmount = (rate, quantity, taxPercent) => {
    const taxable = quantity * rate;
    const taxAmount = (taxable * taxPercent) / 100;
    const grandTotal = taxAmount + taxable;
    return {
      taxAmount,
      taxable,
      grandTotal,
    };
  };

  const handleFileChange = (e) => {
    setValidationErrors((prevErrors) => ({ ...prevErrors, invoiceFile: "" }));
    const selectedFile = e.target.files[0];
    setInvoiceFile(selectedFile);
  };

  const getSingleRawMaterialDetail = async (materialId, index) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get(`raw-material?_id=${materialId}`, {
        headers,
      });

      if (response?.data?.status === true) {
        setRawMaterialDetail(response?.data?.data?.rawMaterials);
        setInputData((prevData) => {
          const updatedProcurementItems = [...prevData.procurementItems];
          updatedProcurementItems[index] = {
            ...updatedProcurementItems[index],
            taxPercent: response?.data?.data?.rawMaterials?.taxPercent || 0,
            unit: response?.data?.data?.rawMaterials?.unit || "",
          };

          return {
            ...prevData,
            procurementItems: updatedProcurementItems,
          };
        });
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const validateProcurementItem = (item) => {
    const errors = {};

    if (!item.material.trim()) {
      errors.material = "Material is required.";
    }

    if (item.quantity.trim() === "") {
      errors.quantity = "Quantity is required.";
    }

    if (item.rate.trim() === "") {
      errors.rate = "Rate is required.";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputData.vendor) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        vendor: "Vendor is required.",
      }));
      return;
    }

    if (!inputData.idNumber) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        idNumber: "ID Number is required.",
      }));
      return;
    }

    if (!inputData.additionalCharges) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        additionalCharges: "Additional Charges is required.",
      }));
      return;
    }

    const procurementItemErrors = inputData.procurementItems.map(
      validateProcurementItem
    );
    if (
      procurementItemErrors.some((errors) => Object.keys(errors).length > 0)
    ) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        procurementItems: procurementItemErrors,
      }));
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("procurement[vendor]", inputData.vendor);
      formData.append("procurement[idNumber]", inputData.idNumber);
      formData.append(
        "procurement[additionalCharges]",
        inputData.additionalCharges
      );
      formData.append("procurement.scannedInvoice", invoiceFile);
      inputData.procurementItems.forEach((item, index) => {
        formData.append(`procurementItems[${index}][material]`, item.material);
        formData.append(`procurementItems[${index}][quantity]`, item.quantity);
        formData.append(`procurementItems[${index}][rate]`, item.rate);
      });

      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      };

      const response = await axios.post("procurement", formData, { headers });

      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        e.target.reset()
        setInputData({
          vendor: "",
          idNumber: "",
          additionalCharges: "",
          procurementItems: Array.from({ length: 1 }, () => ({
            material: "",
            quantity: "",
            rate: "",
          })),
        });
      }
    } catch (error) {
      if (error?.response) {
        let errorMessage = '';
        if (
          error.response?.status === 406
        ) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        }
        else if (
          error.response?.status === 412
        ) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getVendors = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("vendor", { headers });
      if (response?.data?.status === true) {
        setVendors(response?.data?.data?.vendors);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getRawMaterials = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("raw-material", { headers });

      if (response?.data?.status === true) {
        setRawMaterialList(response?.data?.data?.rawMaterials);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const btnDisable = () => {
    let isDisable = false;

    if (
      !inputData.vendor ||
      !inputData.idNumber ||
      !inputData.additionalCharges
    ) {
      isDisable = true;
    }

    for (let i = 0; i < inputData.procurementItems.length; i++) {
      const item = inputData.procurementItems[i];

      if (!item.material || !item.quantity || !item.rate) {
        isDisable = true;
        break;
      }
    }

    return isDisable;
  };

  useEffect(() => {
    getVendors();
    getRawMaterials();
  }, []);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <Container fluid>
          {/* <Row className="mb-4">
                        <Col>
                            <h4 className="fw-semibold mb-0">Purchase Management</h4>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">Purchases</li>
                                    <li className="breadcrumb-item active" aria-current="page">Add Purchase</li>
                                </ol>
                            </nav>
                        </Col>
                    </Row> */}

          <Card className="shadow-sm border-0">
            <Card.Header className="bg-primary text-white py-3">
              <h5 className="mb-0">ADD NEW PURCHASE</h5>
            </Card.Header>
            <Card.Body className="p-4">
              <Form onSubmit={handleSubmit}>
                <Row className="g-3 mb-4">
                  <Col md={6} lg={3}>
                    <Form.Group controlId="vendorSelect">
                      <Form.Label className="fw-semibold">
                        Vendor <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        options={vendors.map((vendor) => ({
                          value: vendor._id,
                          label: vendor.name,
                        }))}
                        value={
                          inputData.vendor
                            ? {
                              value: inputData.vendor,
                              label: vendors.find((vendor) => vendor._id === inputData.vendor)?.name
                            }
                            : null
                        }
                        onChange={(selectedOption) => {
                          if (selectedOption) {
                            handleChange({
                              target: { name: "vendor", value: selectedOption.value },
                            });
                          } else {
                            handleChange({ target: { name: "vendor", value: "" } });
                          }
                        }}
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select Vendor"
                      />
                      {validationErrors.vendor && (
                        <Form.Text className="text-danger">{validationErrors.vendor}</Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={3}>
                    <Form.Group controlId="idNumber">
                      <Form.Label className="fw-semibold">
                        ID Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter ID Number"
                        name="idNumber"
                        value={inputData?.idNumber}
                        onChange={handleChange}
                      />
                      {validationErrors.idNumber && (
                        <Form.Text className="text-danger">{validationErrors.idNumber}</Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={3}>
                    <Form.Group controlId="additionalCharges">
                      <Form.Label className="fw-semibold">
                        Additional Charges <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        min={0}
                        type="number"
                        step="any"
                        placeholder="0.00"
                        name="additionalCharges"
                        value={inputData.additionalCharges}
                        onChange={handleChange}
                      />
                      {validationErrors.additionalCharges && (
                        <Form.Text className="text-danger">{validationErrors.additionalCharges}</Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={3}>
                    <Form.Group controlId="invoiceFile">
                      <Form.Label className="fw-semibold">
                        Scanned Invoice
                      </Form.Label>
                      <Form.Control
                        type="file"
                        onChange={handleFileChange}
                        accept=".txt, .png, .jpg, .jpeg, .pdf, .doc, .docx"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Procurement Items</h5>
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={handleAddItem}
                  >
                    <i className="bi bi-plus-lg me-1"></i> Add Item
                  </Button>
                </div>
                <hr className="mb-4" />

                {inputData.procurementItems.map((item, index) => (
                  <Card key={index} className="mb-3 border">
                    <Card.Body className="p-3">
                      <Row className="g-3">
                        <Col md={4}>
                          <Form.Group controlId={`material-${index}`}>
                            <Form.Label className="fw-semibold">
                              Raw Material <span className="text-danger">*</span>
                            </Form.Label>
                            <Select
                              options={rawMaterialList.map((rm) => ({
                                value: rm._id,
                                label: rm.name,
                              }))}
                              value={
                                item?.material
                                  ? {
                                    value: item.material,
                                    label: rawMaterialList.find((rm) => rm._id === item.material)?.name,
                                  }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                handleChange(
                                  { target: { name: "material", value: selectedOption ? selectedOption.value : "" } },
                                  index
                                );
                              }}
                              classNamePrefix="react-select"
                              isClearable
                              placeholder="Select Material"
                            />
                            {validationErrors.procurementItems[index]?.material && (
                              <Form.Text className="text-danger">
                                {validationErrors.procurementItems[index]?.material}
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={2}>
                          <Form.Group controlId={`quantity-${index}`}>
                            <Form.Label className="fw-semibold">
                              Quantity <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              min={0}
                              step="any"
                              type="number"
                              placeholder="0"
                              name="quantity"
                              value={item.quantity}
                              onChange={(e) => handleChange(e, index)}
                            />
                            {validationErrors.procurementItems[index]?.quantity && (
                              <Form.Text className="text-danger">
                                {validationErrors.procurementItems[index]?.quantity}
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={1}>
                          <Form.Group controlId={`unit-${index}`}>
                            <Form.Label className="fw-semibold">
                              Unit
                            </Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              value={inputData.procurementItems[index]?.unit || ""}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group controlId={`rate-${index}`}>
                            <Form.Label className="fw-semibold">
                              Rate (₹) <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              step="any"
                              min={0}
                              type="number"
                              placeholder="0.00"
                              name="rate"
                              value={item.rate}
                              onChange={(e) => handleChange(e, index)}
                            />
                            {validationErrors.procurementItems[index]?.rate && (
                              <Form.Text className="text-danger">
                                {validationErrors.procurementItems[index]?.rate}
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={2} className="d-flex align-items-end">
                          <div className="d-flex">
                            {inputData.procurementItems.length > 1 && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleRemoveItem(index)}
                                className="ms-2"
                                title="Remove Item"
                              >
                                <i className="bi bi-dash-lg"></i>
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <Row className="g-3 mt-2">
                        <Col md={3}>
                          <Form.Group controlId={`taxPercent-${index}`}>
                            <Form.Label className="fw-semibold">
                              Tax Percent
                            </Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              value={`${inputData.procurementItems[index].taxPercent || "0"}%`}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group controlId={`taxable-${index}`}>
                            <Form.Label className="fw-semibold">
                              Taxable Amount
                            </Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              value={`₹${parseFloat(inputData.procurementItems[index].taxable || "0").toFixed(2)}`}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group controlId={`taxAmount-${index}`}>
                            <Form.Label className="fw-semibold">
                              Tax Amount
                            </Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              value={`₹${parseFloat(inputData.procurementItems[index].taxAmount || "0").toFixed(2)}`}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group controlId={`grandTotal-${index}`}>
                            <Form.Label className="fw-semibold">
                              Grand Total
                            </Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              value={`₹${parseFloat(inputData.procurementItems[index].grandTotal || "0").toFixed(2)}`}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}

                <div className="d-flex justify-content-end mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={btnDisable() || isLoading}
                    className="px-4"
                  >
                    {isLoading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span className="ms-2">Processing...</span>
                      </>
                    ) : (
                      'Submit Purchase'
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddPurchase;